var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #8a2724;\n      }\n\n      .st1 {\n        fill: #ff453a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,10c2.7,0,5-2.2,5-5S7.7,0,5,0,0,2.2,0,5s2.2,5,5,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,7c-.2,0-.4-.2-.4-.4s0-.2.1-.3l1.4-1.4-1.4-1.4c0,0-.1-.2-.1-.3,0-.2.2-.4.4-.4s.2,0,.3.1l1.4,1.4,1.4-1.4c0,0,.2-.1.3-.1.2,0,.4.2.4.4s0,.2-.1.3l-1.4,1.4,1.4,1.4c0,0,.1.2.1.3,0,.2-.2.4-.4.4s-.2,0-.3-.1l-1.4-1.4-1.3,1.4c0,0-.2.1-.3.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ae1dcd3d61d5704ad1ce3609237d9881.svg";
export { ForwardRef as ReactComponent };